<template>
  <div>
    <v-row align-center justify-center>
      <v-col class="grupo text-xs-center">{{mayus(grupo.descripcion_grupo)}}</v-col>
    </v-row>
    <v-row align-center justify-center>
      <template v-for="(nota, i) in grupo.notas">
        <v-col
          class="header"
          :key="i"
          :class="[mayus(grupo.descripcion_grupo) != 'Examenes'? 'xs2' : 'xs5']"
        >
          <itemNota :nota="nota" />
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import itemNota from "./itemNota";

export default {
  data() {
    return {};
  },
  components: {
    itemNota
  },
  props: ["grupo"],
  mounted: function() {
    //console.log("mounted -> itemGrupo !", this.grupo);
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    }
  }
};
</script>

<style scoped>
.grupo {
  /*padding: 0px 0 10px 10px;*/
  font-size: 14px;
  background-color: #4caf50ed;
}
/*
.header {
 background-color: #4caf50ed;
}*/
</style>